import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
const VALUE_STACK_CHECKOUT_URL = 'https://chimica-visiva2026.impultienda.ar/checkout';
const rows = [{
  label: 'Volume 1 — Materia e trasformazioni',
  price: '47 €'
}, {
  label: 'Volume 2 — Struttura atomica e periodicità',
  price: '47 €'
}, {
  label: 'Volume 3 — Legami chimici e struttura molecolare',
  price: '47 €'
}, {
  label: 'Volume 4 — Reazioni chimiche e stechiometria',
  price: '47 €'
}, {
  label: 'Volume 5 — Chimica organica e biosistemi',
  price: '47 €'
}, {
  label: 'Bonus 1 — Chimica in gioco™',
  price: '47 €'
}, {
  label: 'Bonus 2 — Chimica in azione™',
  price: '47 €'
}, {
  label: 'Bonus 3 — Valutazione formativa™',
  price: '47 €'
}, {
  label: 'Bonus 4 — Aula di chimica visiva™',
  price: '47 €'
}];
export function ValueStack() {
  return <section id="get-access" className="w-full scroll-mt-20 bg-white px-5 py-6 sm:py-12" data-id="element-241" data-mp="35pd73suxp3ky">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4
    }} className="mx-auto max-w-[600px]" data-id="element-242" data-mp="1tetp0ac885vv">
        <h2 className="text-center font-serif-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-243" data-mp="236r25mmsp7x8">
          Tutto ciò che ricevi oggi
        </h2>

        <div className="mt-5 rounded-2xl border border-cobalt/25 p-4 sm:mt-8 sm:p-6" data-id="element-244" data-mp="2c5upj2szw9hj">
          <ul data-id="element-245" data-mp="2c7p9oewfzxkk">
            {rows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 border-b border-dashed border-cobalt/20 py-2 last:border-b-0 sm:py-2.5" data-id="element-246" data-mp="2837t0oldq0e0">
                <span className="text-[13px] text-ink/80 sm:text-sm" data-id="element-247" data-mp="2h68ugbzav3bc">{row.label}</span>
                <span className="shrink-0 text-[13px] font-medium text-ink/60 sm:text-sm" data-id="element-248" data-mp="rr2fkwdgeawy">
                  {row.price}
                </span>
              </li>)}
          </ul>

          <div className="my-4 h-px w-full bg-cobalt/30" data-id="element-249" data-mp="2mtxrk945oelg" />

          <div className="flex items-center justify-between" data-id="element-250" data-mp="2mvim3yqgzxjb">
            <span className="text-[13px] text-ink/60 sm:text-sm" data-id="element-251" data-mp="2rssjc0k3pdhp">Valore complessivo</span>
            <span className="text-lg font-medium text-ink/50 line-through sm:text-xl" data-id="element-252" data-mp="2vt2nr8s8vvug">423 €</span>
          </div>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-cobalt/10 py-5 text-center sm:py-6" data-id="element-253" data-mp="30ui971yc44dd">
            <span className="text-sm font-medium text-cobalt-deep" data-id="element-254" data-mp="35rrxge9zm9zm">Prezzo di oggi</span>
            <span className="font-serif-display text-5xl font-bold text-cobalt sm:text-6xl" data-id="element-255" data-mp="3apjzi14cjchj">
              19 €
            </span>
            <p className="mt-2 px-4 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-256" data-mp="3fk7glex0t4m3">
              Pagamento unico · Nessun abbonamento · Accesso senza scadenza
            </p>
            <p className="mt-1 px-4 text-xs text-ink/60 sm:text-sm" data-id="element-257" data-mp="3okcmfkmkfuy5">
              Consegna digitale immediata tramite e-mail
            </p>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-258" data-mp="7h6ohsjm3t7d">
          <div className="mb-6 flex flex-col items-center text-center sm:mb-8" data-id="element-259" data-mp="7e2f8grai79u">
            <span className="text-xs font-bold uppercase tracking-widest text-cobalt-deep" data-id="element-260" data-mp="2fhfeify9plx">
              Uno sguardo all’interno del sistema
            </span>
            <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-261" data-mp="3pma2k2rk3fjx">
              Anteprima dei materiali di <span className="text-cobalt" data-id="element-262" data-mp="q65064ays9pw">CHIMICA VISIVA™</span>
            </h3>
            <p className="mt-2 text-sm font-medium text-ink/70 sm:text-base" data-id="element-263" data-mp="l8lckdsdmkla">
              Schede teoriche visive, attività, laboratori e verifiche già organizzati per argomento
              e pronti da stampare.
            </p>

            <div className="mt-5 w-full overflow-hidden rounded-xl border border-cobalt/20 bg-paper shadow-sm sm:mt-6" data-id="element-264" data-mp="cd5l23f3ghiv">
              <video src="https://cdn.magicpatterns.com/uploads/deRG6qgDqbf6A72j12R72g/VIDEO_PARA_WEB_OPTIMIZADO.mp4" autoPlay loop muted playsInline className="aspect-square w-full object-cover" data-id="element-265" data-mp="146fqn68d3maj" />
            </div>
          </div>

          <CTAButton label="OTTIENI CHIMICA VISIVA™ ORA" href={VALUE_STACK_CHECKOUT_URL} external data-id="element-266" data-mp="forn7erjpsx7" />
          <p className="mt-2.5 text-center text-xs text-ink/60 sm:text-sm" data-id="element-267" data-mp="jr4sk22drotg">
            19 € · Pagamento unico · Nessun abbonamento
          </p>
          <TodayOfferCard data-id="element-268" data-mp="1ce8u1x29ll0h" />
          <div className="mt-4 rounded-xl border border-cobalt/20 bg-cobalt/5 px-4 py-3 text-center" data-id="element-269" data-mp="1cdh34zjm4bgj">
            <p className="text-sm font-bold text-cobalt-deep" data-id="element-270" data-mp="ymc2pv8f7f55">🔒 Pagamento sicuro</p>
            <p className="mt-1 text-xs leading-relaxed text-ink/70 sm:text-sm" data-id="element-271" data-mp="12mutrn2hoh6a">
              Sono accettate le principali carte di credito e di debito. Il pagamento di 19 € viene elaborato in modo sicuro.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}